import React from "react";
// Customizable Area Start
import OwnershipScreenController, { Props } from "./OwnershipScreenController.web";
import NavigationMenu from "../../navigationmenu/src/NavigationMenu.web";
import { Box, CircularProgress, IconButton, Typography } from "@material-ui/core";
import RightSideBar from "../../activityfeed/src/RightSideBar.web";
import { backArrowDark, backArrowWhite } from "../../groups/src/assets";
import { arrowLogo } from "../../navigationmenu/src/assets";
import { BarChart } from "../../../components/src/BarChart.web";
// Customizable Area End

export default class OwnershipScreen extends OwnershipScreenController {
    constructor(props: Props) {
        super(props);
        // Customizable Area Start
        // Customizable Area End
    }
    // Customizable Area Start

    // Customizable Area End

    render() {
        // Customizable Area Start
        const { checked, navigation } = this.props
        return (
            <NavigationMenu id="" tabItem="Earnings" checked={checked} navigation={navigation}>
                <Box style={webStyles.container}>
                    <Box style={webStyles.leftPane}>
                        <Box style={webStyles.headingContainer}>
                            <IconButton onClick={this.navigateToEarnigs} data-test-id="back-btn">
                                <img src={checked ? backArrowDark : backArrowWhite} style={{ width: '24px', height: '24px' }} />
                            </IconButton>
                            <Typography style={{ ...webStyles.headingTitle, color: checked ? '#222222' : '#fff' }}>Ownership</Typography>
                        </Box>

                        {this.state.loading ? (
                            <Box style={{ display: 'flex', alignItems: 'center', flex: 'auto', justifyContent: 'center' }}>
                                <CircularProgress color="primary" />
                            </Box>
                        ) : (
                            <>
                                <Box style={webStyles.logoContainer}>
                                    <img src={arrowLogo} style={webStyles.logo} />
                                    <Typography style={{ ...webStyles.logoText, color: checked ? '#222222' : '#fff' }}>
                                        Arrows Social, Inc.
                                    </Typography>
                                </Box>

                                <Box style={{...webStyles.coastingCard, background: checked ? '#E9E9E9' : '#181818'}}>
                                    <Typography style={webStyles.coastCardText}>
                                        Current Price/Share = ${parseFloat(this.state.current_price_and_share.toString()).toFixed(2)}
                                    </Typography>
                                    <Box style={webStyles.hrLine} />
                                    <Typography style={webStyles.coastCardText}>
                                        Shares Purchased = {parseFloat(this.state.share_purchased.toString()).toFixed(2)}
                                    </Typography>
                                </Box>

                                <Box style={{ paddingLeft: '10px', marginTop: '34px' }}>
                                    <BarChart 
                                        chartOptions={this.state.chartOptions} 
                                        series={this.state.series} 
                                        headingStyle={{ marginBottom: '21px' }}
                                        title="Monthly Referral Revenue"
                                        checked={checked}
                                    />
                                </Box>

                                <Box style={{ ...webStyles.coastingCard, marginTop: '34px', background: checked ? '#E9E9E9' : '#181818' }}>
                                    <Typography style={webStyles.coastCardText}>
                                        Cost Basis = ${parseFloat(this.state.cost_basis.toString()).toFixed(2)}
                                    </Typography>
                                    <Box style={webStyles.hrLine} />
                                    <Typography style={webStyles.coastCardText}>
                                        Total Share Value = ${parseFloat(this.state.total_share_value.toString()).toFixed(2)}
                                    </Typography>
                                </Box>
                            </>
                        )}
                    </Box>

                    <RightSideBar checked={checked} navigation={navigation} />
                </Box>
            </NavigationMenu>
        );
        // Customizable Area End
    }
}

// Customizable Area Start
const webStyles = {
    container: {
        display: "flex",
        width: "100%",
    },
    leftPane: {
        width: '60%',
        display: "flex",
        padding: '24px',
        flexDirection: "column",
        "@media (max-width:1000px)": {
            width: "80%",
        },
    } as React.CSSProperties,
    headingContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    } as React.CSSProperties,
    headingTitle: {
        fontSize: '18px',
        fontWeight: 800,
        fontFamily: 'Manrope',
        lineHeight: '24px',
    },
    label: {
        fontSize: '18px',
        lineHeight: '24px',
        fontWeight: 800,
        fontFamily: 'Manrope',
        color: '#fff',
        marginBottom: '15px',
    },
    logoContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '34px',
        marginBottom: '20px',
        gap: '15px',
    } as React.CSSProperties,
    logo: {
        width: '65.72px',
        height: '64px',
    },
    logoText: {
        fontSize: '24px',
        lineHeight: '36px',
        fontWeight: 800,
        fontFamily: 'Manrope',
    },
    coastingCard: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #5B5B5B',
        borderRadius: '10px',
        padding: '15px 64.5px 15px 64.5px',
        background: '#181818',
        alignSelf: 'center',
    } as React.CSSProperties,
    coastCardText: {
        fontSize: '16px',
        lineHeight: '20px',
        fontWeight: 600,
        fontFamily: 'Manrope',
        marginLeft: '27px',
        marginRight: '27px',
    },
    hrLine: {
        height: '1px',
        background: '#4E4E4E',
        marginTop: '15px',
        marginBottom: '15px',
        width: '100%',
    } as React.CSSProperties,
}

// Customizable Area End
